"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Icon = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M16 12h-1v-2h-2V7h1v2h1V7h1v5zm-5-2H9v1h2v1H8V9h2V8H8V7h3v3zm8-3V4H5v3H2v13h8v-4h4v4h8V7h-3z", fill: "#8C9BA5" }, void 0) }), void 0));
const SvgStore24Hour = (0, react_1.memo)(Icon);
exports.default = SvgStore24Hour;
//# sourceMappingURL=Store24Hour.js.map